module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/maneuvers_bg_with_news.44f9df45.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/maneuvers_bg_with_news.png
// module id = 3021
// module chunks = 11